<template>
  <div>
    <!-- Partially activated -->
    <v-list
      v-if="activatedInSomeStores && !loading"
      two-line
    >
      <v-list-tile
        class="pr-2 py-2 list-tile-auto-height"
        :class="{'list-tile-column-layout': $vuetify.breakpoint.xs}"
      >
        <v-avatar>
          <v-icon
            x-large
            class="msr--text"
          >
            flag
          </v-icon>
          <v-icon
            v-if="campaign.activation_date"
            class="success--text"
            style="position: absolute; left: 10px; top: 12px;"
          >
            check_circle
          </v-icon>
        </v-avatar>
        <v-list-tile-content :class="{'mt-2': $vuetify.breakpoint.xs}">
          <v-subheader class="auto-height">
            <v-layout column>
              {{ campaignActivatedPartiallyText }}
              <campaign-activation-timings-list :campaign="campaign" />
            </v-layout>
          </v-subheader>
        </v-list-tile-content>
        <v-list-tile-action :class="{'mt-2': $vuetify.breakpoint.xs}">
          <campaign-deactivation-button
            class="mr-2"
            :deactivating="deactivating"
            @click="$emit('deactivate')"
          />
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <!-- Fully activated -->
    <v-list
      v-if="activatedEverywhere && !loading"
      three-line
    >
      <v-list-tile
        class="pa-2 list-tile-auto-height"
        :class="{'list-tile-column-layout': $vuetify.breakpoint.xs}"
      >
        <v-list-tile-action>
          <v-icon
            x-large
            color="success"
          >
            check_circle
          </v-icon>
        </v-list-tile-action>
        <v-list-tile-content :class="{'mt-2': $vuetify.breakpoint.xs}">
          <v-subheader class="auto-height">
            <v-layout column>
              {{ campaignActivatedEverywhereText }}
              <campaign-activation-timings-list :campaign="campaign" />
            </v-layout>
          </v-subheader>
        </v-list-tile-content>
        <v-list-tile-action :class="{'mt-2': $vuetify.breakpoint.xs}">
          <!-- Deactivation Button -->
          <campaign-deactivation-button
            class="mr-2"
            :deactivating="deactivating"
            @click="$emit('deactivate')"
          />
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
import dayjs from 'dayjs';

import timing from '@/mixins/timing';

import CampaignActivationTimingsList from '@/components/CampaignActivationTimingsList';
import CampaignDeactivationButton from '@/components/CampaignDeactivationButton';

export default {
  name: 'CampaignActivationStatus',
  components: {
    CampaignActivationTimingsList,
    CampaignDeactivationButton,
  },
  mixins: [timing],
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    deactivating: {
      type: Boolean,
      required: true,
    },
    activatedInSomeStores: {
      type: Boolean,
      required: true,
    },
    activatedEverywhere: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    showDeactivateCampaignButton() {
      const activated = this.activatedInSomeStores || this.activatedEverywhere;
      return activated && this.campaign.can_be_deactivated;
    },
    activationDate() {
      if (!this.campaign) {
        return null;
      }
      return this.campaign.activation_date;
    },
    campaignActivatedPartiallyText() {
      let text = this.$t('campaignActivatedPartially');
      text = text.replace(
        '{{ activated }}',
        this.normalizeDateForHumans(this.activationDate)
      );
      text = text.replace('{{ numStores }}', this.campaign.activations.length);
      return text;
    },
    campaignActivatedEverywhereText() {
      let text = this.$t('campaignActivatedEverywhere');
      text = text.replace(
        '{{ activated }}',
        this.normalizeDateForHumans(this.activationDate)
      );
      return text;
    },
  },
  methods: {
    normalizeDateForHumans(dateString, fixStopDate = false) {
      if (dateString === null) {
        return '';
      }
      let date = new Date(dateString);
      if (fixStopDate) {
        date = this.subtractOneDayFromDate(date);
      }
      date.setHours(0, 0, 0, 0);
      return dayjs(date).format('DD.MM.YYYY');
    },
  },
};
</script>

<style scoped>
.list-tile-column-layout >>> .v-list__tile {
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/CampaignActivationStatus.vue